export const GENERATED_IDS = {
    "__TALENT_ID": {
        "MAGE": {
            "FROST": {},
            "FIRE": {},
            "ARCANE": {}
        },
        "WARRIOR": {
            "PROT": {},
            "FURY": {},
            "ARMS": {}
        },
        "ROGUE": {
            "SUB": {},
            "ASS": {},
            "OUT": {}
        },
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "DH": {
            "VENG": {},
            "HAVOC": {}
        },
        "DRUID": {
            "GUARDIAN": {},
            "FERAL": {},
            "BALANCE": {},
            "RESTO": {
                "INNER_PEACE": "f8e49a4b-ced6-4584-aef5-a4cc7cbb686d",
                "TREE": "d99f4df1-d142-4909-a952-7b5ea93906c7"
            }
        },
        "PRIEST": {
            "DISC": {},
            "HOLY": {
                "SALV": "b50cfd45-7dba-4fcd-8e72-feb0ef624a8a"
            },
            "SHADOW": {}
        },
        "DK": {
            "FROST": {},
            "UNHOLY": {},
            "BLOOD": {}
        },
        "PALADIN": {
            "RET": {},
            "PROT": {},
            "HOLY": {
                "HOLY_AVENGER": "d2063e10-90b1-448a-b5c0-1d370c71c837",
                "CRUSADER": "50bb4dcb-67ba-4918-99f4-973cf6a8ea6a"
            }
        },
        "SHAMAN": {
            "ENH": {
                "WRT": "87738407-8a7b-432c-8e2e-9c4cb2d58b11"
            },
            "ELE": {
                "ANCE_GUIDE": "b71d476d-fcd1-4089-8f05-41f3ab040c9f",
                "WRT": "a92016f1-a0e6-4fee-94ed-537fa3a97e1f"
            },
            "RESTO": {
                "ASC": "d52a3dcd-5ed4-4899-8b8a-62c6dd034c87",
                "APT": "84df57e1-4be9-4b3e-a34c-70da96eb7645",
                "WRT": "33ae2e3c-3947-4934-ac4e-568efee29afc"
            }
        },
        "MONK": {
            "WW": {},
            "MW": {
                "CHI_JI": "fed26e25-05e0-4674-b127-01ed2eb8ac2a"
            },
            "BRM": {}
        },
        "HUNTER": {
            "MM": {},
            "SV": {},
            "BM": {}
        }
    },
    "__MODIFIER_ID": {
        "BOON": "d8d3935a-52cd-4883-933c-3737063b143d",
        "FALLEN_ORDER": "8a99ad10-a7f5-4ce9-9fc6-c5c1e0486710",
        "CONVOKE": "2f4c75cc-8c8d-48ec-968e-72b90050b705",
        "ASHEN_HALLOW": "e39625ed-4e08-476b-aaac-90a495d7beb5",
        "CELEST_SPIRIT": "84c81ea5-9ed2-4607-96cd-15be63764e20",
        "CHAIN_HARVEST": "915d1163-de60-4feb-8c61-fdc7f6b1a417"
    },
    "__SPELL_ID": {
        "MAGE": {
            "FROST": {},
            "FIRE": {},
            "ARCANE": {}
        },
        "WARRIOR": {
            "PROT": {
                "RALLY": "dff976d9-8ef6-485e-bf48-ac305ab178d4"
            },
            "FURY": {
                "RALLY": "6da0313b-3ecb-4c8d-b29d-2eaed694f65b"
            },
            "ARMS": {
                "RALLY": "7dcf7756-720b-4ebf-825b-79f077d4f039"
            }
        },
        "ROGUE": {
            "SUB": {},
            "ASS": {},
            "OUT": {}
        },
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "DH": {
            "VENG": {},
            "HAVOC": {
                "DARK": "98672799-84c5-429c-8925-4d3397527e01"
            }
        },
        "DRUID": {
            "GUARDIAN": {
                "CONVOKE": "e941017d-4474-40c5-8a0b-a72a99a1baf4",
                "ROAR": "fefc79c3-74ce-40e9-9656-52d2fabb625e"
            },
            "FERAL": {
                "CONVOKE": "ea3411a1-5932-41a1-afdf-0e4591f7e36c",
                "ROAR": "420ed3be-57c9-4db7-8ddc-8b2b0c5ffffc"
            },
            "BALANCE": {
                "CONVOKE": "1e5ad5a2-7784-4fe5-b50b-c0a65d7db880",
                "ROAR": "baca27d3-f4a6-47c2-be00-f07e2b575b24"
            },
            "RESTO": {
                "TRANQ": "55783ba5-09a5-4b80-9c77-a5bc6283d088",
                "CONVOKE": "3e0bde1d-6430-47c6-9fa2-7e70b5f804dc",
                "ROAR": "35c2206c-689f-4194-b7cf-37cbcf5356ab",
                "TREE": "25346dfb-4290-45e7-8052-b4e885ddfb7e"
            }
        },
        "PRIEST": {
            "DISC": {
                "RAMP": "bacb0d1f-6f61-476f-930b-90c9711836ee",
                "SMALL_RAMP": "78ab8e9d-7506-499f-a82a-091756d305d2",
                "BARRIER": "dc70ac3c-b104-4afb-8d23-e5fabb8a6530",
                "BIG_RAMP": "f13e1cb6-bc98-416f-850e-c01b0030d32b"
            },
            "HOLY": {
                "HYMN": "47023d71-7356-4c76-9153-0e7a9ea1df54",
                "BOON": "aeb49287-7ee4-4ddd-b9a8-16a3f8500358",
                "SYMBOL_OF_HOPE": "ca996ba0-a0b2-478b-95de-7a6996dc3742",
                "SALV": "75bcded4-a545-4296-8e45-e6802c1117b3"
            },
            "SHADOW": {
                "EMBRACE": "d5dbdfcf-cd05-4b45-9966-2bb2a8ef90b2"
            }
        },
        "DK": {
            "FROST": {
                "AMZ": "a9d614b7-18a4-4ca0-a934-32e84f87ac60"
            },
            "UNHOLY": {
                "AMZ": "e7aa873a-32af-48d6-bd00-f9e597c2b8b2"
            },
            "BLOOD": {
                "AMZ": "2c42c8de-597a-4eca-89e6-d9352c6ef35f"
            }
        },
        "PALADIN": {
            "RET": {
                "ASHEN_HALLOW": "5ef053f3-4036-4d62-89c9-979bb910ad87"
            },
            "PROT": {
                "ASHEN_HALLOW": "a42ac7df-6560-4126-ab9b-c8dc3900978b"
            },
            "HOLY": {
                "HOLY_AVENGER": "8ac0fe12-4c14-4e2b-ac5c-3b6317dc1169",
                "CRUSADER": "e41cea3b-6d65-47c9-ac29-c11aa8c1cc5a",
                "WINGS": "850a87b9-59e7-4dcb-8e9e-ce2bf3e6c3bd",
                "ASHEN_HALLOW": "7acb028f-02cc-48b8-abed-e0f75f1635c3",
                "AM": "331c4193-2566-43fb-ab6f-ab3bf325649c"
            }
        },
        "SHAMAN": {
            "ENH": {
                "WRT": "c5b13d8b-58a4-4258-81af-ac84d0bc4551"
            },
            "ELE": {
                "ANCE_GUIDE": "1b6511cf-f251-4ea4-a498-5f704245c447",
                "WRT": "cfa6f550-c73e-4cca-99ae-cb597c248b4d"
            },
            "RESTO": {
                "ASC": "b6e57eb2-3f07-406b-8e1f-3db0843cff27",
                "APT": "45c7a0ed-9cd6-4c1b-884c-9f4a18b13edb",
                "WRT": "76d13866-3729-4afe-a828-01defed08a4d",
                "HTT": "b7a13dfd-6cd8-4611-a291-c8f3848034a3",
                "SLT": "cadbe329-0d56-41d6-b584-f0984dc62384",
                "CHAIN_HARVEST": "f60cb8fe-14c1-40ca-8e48-ac2a7d5e9e53"
            }
        },
        "MONK": {
            "WW": {},
            "MW": {
                "REVIVAL": "8175ecd3-3459-4e43-a548-a82c72438ca2",
                "YULON": "787d2fd6-ec33-40a5-85a1-565acc981155",
                "FALLEN_ORDER": "ce31e945-0c73-4d77-8fca-5a0696f2aa41",
                "CHI_JI": "046b39bc-29e0-4964-989e-48f112e27e9f"
            },
            "BRM": {}
        },
        "HUNTER": {
            "MM": {},
            "SV": {},
            "BM": {}
        }
    }
}
